import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { styled } from "@mui/system";

export const StyledAlertDialog = styled(Dialog)(({ theme }) => ({
  backgroundColor: "rgba(0,0,0,.3)",
  "& .paper": {
    width: "600px",
    borderRadius: "8px",
    boxShadow: "10px 10px 18px 0 rgba(0, 0, 0, 0.2)",
    backgroundColor: "#ffffff",
    "@media (max-width: 420px)": {
      overflow: "hidden",
      margin: "0 15px"
    }
  }
}));

export const StyledAlertDialogTitle = styled(DialogTitle)(({ theme }) => ({
  textAlign: "center",
  padding: "15px 40px 0px 40px",
  "& > h2": {
    fontSize: "24px",
    fontWeight: 600,
    lineHeight: 1.33,
    letterSpacing: "normal"
  }
}));

export const StyledCloseIcon = styled(CloseIcon)(({ theme }) => ({
  fontSize: "30px",
  border: "3px solid red",
  borderRadius: "50px",
  padding: "5px"
}));

export const StyledAlertDialogContent = styled(DialogContent)(({ theme }) => ({
  padding: "5px 30px",
  fontSize: "15px"
}));

export const StyledAlertDialogActions = styled(DialogActions)(({ theme }) => ({
  alignItems: "center",
  padding: "15px",
  justifyContent: "center",
  "& > * + *": {
    marginLeft: "20px"
  },
  "& .btnContainer": {
    padding: "5px",
    width: "100%"
  },
  "& .agentBtnContainer": {
    padding: "5px",
    width: "100%",
    textAlign: "center"
  },
  "& .ml0": {
    marginLeft: "0 !important",
    textAlign: "center"
  }
}));

export const StyledAlertActionButtons = styled(Button)(({ theme }) => ({
  width: "200px",
  height: "40px",
  borderRadius: "21px",
  textTransform: "capitalize",
  fontSize: "16px",
  fontWeight: 500,
  letterSpacing: "normal",
  "&.MuiButton-contained": {
    color: "#fff",
    backgroundColor: "#000"
  },
  "&.MuiButton-outlined": {
    color: "#3b3a3a",
    border: "1px solid #3b3a3a"
  },
  "@media (max-width: 372px)": {
    width: "100%",
    marginLeft: 0
  }
}));

export const StyledAlertAgentActionButtons = styled(Button)(({ theme }) => ({
  "&.MuiButton-root": {
    width: "200px",
    height: "40px",
    borderRadius: "21px",
    textTransform: "capitalize",
    fontSize: "16px",
    fontWeight: 600,
    letterSpacing: "normal",
    "&.MuiButton-contained": {
      color: "#fff",
      backgroundColor: "#000"
    },
    "@media (max-width: 372px)": {
      width: "100%",
      marginLeft: 0
    }
  }
}));
